<template>
  <div class="modal-toast abs-mc zi1000" :style="{maxWidth}" :class="hidden">
    <render v-if="render" :render="render" :others="others"></render>
    <div class="" v-else-if="content !== undefined">{{content}}</div>
    <slot v-else></slot>
  </div>
</template>

<script>
  import render from '../render';

  export default {
    name: "ModalToast",
    props: {
      render: Function,
      content: '',
      delayed: {
        type: Number,
        default: 2000,
      },
      maxWidth: {
        type: String,
        default: '50vw',
      },
    },
    components: {
      render,
    },
    data() {
      return {
        timer: null,
        hidden: false,
      };
    },
    mounted() {
      if (this.delayed !== 0) {
        this.timer = setTimeout(this.close, this.delayed);
      }
    },
    methods: {
      close() {
        clearTimeout(this.timer);
        this.timer = null;
        this.hidden = true;
        setTimeout(() => this.$emit('closed', this), 300);
      },
    },
  }
</script>

<style scoped lang="less">
  .modal-toast {
    padding: 10px 18px;
    background-color: rgba(0, 15, 34, .7);
    border-radius: 4px;
    color: #fff;
    word-wrap: break-word;
    opacity: 1;
    transition: opacity 300ms;
    &.hidden {
      opacity: 0;
    }
  }
</style>